import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import { MentionsInput, Mention } from 'react-mentions';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import { getLengthLabel } from '../../../../Components/helper';

const defaultStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },
  '&singleLine': {
    display: 'inline-block',
    width: 180,
    highlighter: {
      padding: 1,
    },
    input: {
      border: 'none',
      marginTop: 10,
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      // eslint-disable-next-line sonarjs/no-duplicate-string
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      width: '300px',
      maxHeight: '100px',
      overflow: 'auto',
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#f5f5f5',
      },
      color: '#000',
    },
  },
};

const customValueRenderer = (selected, _options, val) => {
  // to add label
  if (!selected || selected?.length === 0) {
    return val;
  }
  if (selected?.length === _options?.length) {
    return 'All Items are selected';
  }
  return selected.length ? selected.map(({ label }) => label).join(', ') : val;
};

const subArray1 = [
  {
    type: 'designDocument',
    name: 'Design/Details Documents',
    type2: 'document',
    options: 'designDocumentOptions',
  },
  {
    type: 'colourDocument',
    name: 'Colour Documents',
    type2: 'document',
    options: 'colourDocumentOptions',
  },
  {
    type: 'bomDocument',
    name: 'BOM Documents',
    type2: 'document',
    options: 'bomDocumentOptions',
  },
  {
    type: 'otherSpecificationDoc',
    name: 'Specification Documents',
    type2: 'document',
    options: 'otherDocumentOptions',
  },
  { type: 'pomImgs', name: 'POM Guide' },
  {
    type: 'poDocuments',
    name: 'P.O. Documents',
    type2: 'document',
    options: 'poDocumentOptions',
  },
  { type: 'test-report', name: 'Testing Reports' },
  { type: 'care-label-layout', name: 'Care/User Instructions Layout' },
];

const cpArray = ['po'];
const tpArray = ['design-details', 'bom', 'measurement', 'care', 'testing', 'sample'];
const subArray = [
  'designDocument',
  'pomImgs',
  'colourDocument',
  'pattern',
  'test-report',
  'care-label-layout',
  'bomDocument',
  'document',
  'poDocuments',
  'otherSpecificationDoc',
];
const technicalPackageArray = [
  { name: 'Design/Details', type: 'design-details' },
  { name: 'Bill of Materials (BOM)', type: 'bom' },
  { name: 'Measurements', type: 'measurement' },
  { name: 'Testing Requirements', type: 'testing' },
  { name: 'Care/User Instructions', type: 'care' },
];

export const costingAndPurchasing = (mainState, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, t) => {
  const { index } = mainState;
  return (
    <div className="col-md-4 mb-3 mb-md-0">
      <div className="listing-card card h-100 mb-16">
        <div className="card-header">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.COSTING_PURCHASING')}</div>
        <div className="card-body">
          <div className="form-group">
            <div className="common-checkbox size-sm">
              <input id="cp-all" type="checkbox" checked={checkIsChecked(cpArray)} onChange={(e) => handleSelectAll('cp', e.target.checked, cpArray)} />
              <label htmlFor="cp-all" className="chklabel">
                <span className="f-16 font-medium">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_ALL')}</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <div className="m-control-outer user-right-popup d-flex align-items-center">
              <div className="common-checkbox size-sm">
                <input id={`${index}po`} type="checkbox" checked={checkIsChecked([], 'po')} onChange={() => handleSelect('po')} />
                <label htmlFor={`${index}po`} className="chklabel" />
              </div>
              <div className="multiselect-box po-select p-relative flex-fill ml-10">
                <div className="custom-react-select">
                  <MultiSelect
                    name="group"
                    options={mainState?.poOptions}
                    className="product-custom-multiselect common-new-multiselect w-100"
                    value={multiselectValues('poOptions', 'pos')}
                    labelledBy="Purchase Orders"
                    onChange={(selected) => {
                      handleSelectChange(
                        selected.map((val) => val._id),
                        'pos',
                      );
                    }}
                    valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Purchase Orders')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const otherPackage = (mainState, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, t) => {
  const falsyValues = (tech) => {
    return mainState?.gradingGroups && tech?.type === 'pattern' ? multiselectValues('gradingGroups', 'cadGradGroup') : '';
  };
  return (
    <div className="col-md-4 mb-3 mb-md-0">
      <div className="listing-card card h-100 mb-16">
        <div className="card-header">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.OTHER')}</div>
        <div className="card-body">
          <div className="form-group">
            <div className="common-checkbox size-sm">
              <input id="sub-all" type="checkbox" checked={checkIsChecked(subArray)} onChange={(e) => handleSelectAll('sub', e.target.checked, subArray)} />
              <label htmlFor="sub-all" className="chklabel">
                <span className="f-16 font-medium">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_ALL')}</span>
              </label>
            </div>
          </div>
          {subArray1.map((tech, idx) =>
            tech.type2 ? (
              <div className="form-group" key={idx}>
                <div className="m-control-outer user-right-popup d-flex align-items-center">
                  <div className="common-checkbox size-sm">
                    <input id={`other${idx}`} type="checkbox" checked={checkIsChecked([], tech.type)} onChange={() => handleSelect(tech.type, tech.options)} />
                    <label htmlFor={`other${idx}`} className="chklabel" />
                  </div>
                  <div className="multiselect-box po-select p-relative flex-fill ml-10">
                    <div className="custom-react-select">
                      <MultiSelect
                        name="group"
                        options={mainState[tech.options]}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        style={{ width: '50px' }}
                        value={multiselectValues(tech.options, `selected${tech.options}`)}
                        labelledBy={tech.name}
                        onChange={(selected) => {
                          handleSelectChange(
                            selected.map((val) => val._id),
                            `selected${tech.options}`,
                          );
                        }}
                        valueRenderer={(selected, _options) => customValueRenderer(selected, _options, tech.name)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div key={tech?.type || idx}>
                {tech?.type === 'pomImgs' || tech?.type === 'pattern' ? (
                  <div className="form-group">
                    <div className="m-control-outer user-right-popup d-flex align-items-center">
                      <div className="common-checkbox size-sm">
                        <input
                          id={`measurements${idx}`}
                          type="checkbox"
                          checked={checkIsChecked([], tech.type)}
                          onChange={() => handleSelect(tech.type, tech.options)}
                        />
                        <label htmlFor={`measurements${idx}`} className="chklabel" />
                      </div>
                      <div className="multiselect-box po-select p-relative flex-fill ml-10">
                        <MultiSelect
                          name="label"
                          options={mainState?.gradingGroups || []}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={
                            mainState?.gradingGroups && tech?.type === 'pomImgs'
                              ? multiselectValues('gradingGroups', 'selectedgradingOptions')
                              : falsyValues(tech)
                          }
                          labelledBy={tech.name}
                          onChange={(selected) => {
                            handleSelectChange(
                              selected.map((val) => val.value),
                              tech?.type === 'pattern' ? 'cadGradGroup' : 'selectedgradingOptions',
                            );
                          }}
                          valueRenderer={(selected, _options) => customValueRenderer(selected, _options, tech.name)}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="form-group" key={idx}>
                    <div className="common-checkbox size-sm">
                      <input id={`other${idx}`} type="checkbox" checked={checkIsChecked([], tech.type)} onChange={() => handleSelect(tech.type)} />
                      <label htmlFor={`other${idx}`} className="chklabel">
                        <span className="f-16 font-medium">{tech.name}</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};
export const technicalPackage = (mainState, handleSelectAll, checkIsChecked, handleSelect, handleSelectChange, multiselectValues, getValue, t) => {
  const { index } = mainState;
  return (
    <div className="col-md-4 mb-3 mb-md-0">
      <div className="listing-card card h-100 mb-16">
        <div className="card-header">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.TECHNICAL_PACKAGE')}</div>
        <div className="card-body">
          <div className="form-group">
            <div className="common-checkbox size-sm">
              <input id="tp-all" type="checkbox" checked={checkIsChecked(tpArray)} onChange={(e) => handleSelectAll('tp', e.target.checked, tpArray)} />
              <label htmlFor="tp-all" className="chklabel">
                <span className="f-16 font-medium">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_ALLS')}</span>
              </label>
            </div>
          </div>
          {technicalPackageArray.map((tech, idx) => (
            <div className="form-group" key={idx}>
              <div className="common-checkbox size-sm">
                <input id={`tech${idx}`} type="checkbox" checked={checkIsChecked([], tech.type)} onChange={() => handleSelect(tech.type)} />

                {tech?.type === 'measurement' ? (
                  <div className="form-group">
                    <div className="m-control-outer user-right-popup d-flex align-items-center">
                      <div className="common-checkbox size-sm">
                        <input id={`measurementss${idx}`} type="checkbox" checked={checkIsChecked([], tech.type)} onChange={() => handleSelect(tech.type)} />
                        <label htmlFor={`measurementss${idx}`} className="chklabel" />
                      </div>
                      <div className="multiselect-box po-select p-relative flex-fill ml-10">
                        <MultiSelect
                          name="label"
                          options={mainState?.gradingGroups || []}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={mainState?.gradingGroups ? multiselectValues('gradingGroups', 'specificationGradGroup') : ''}
                          labelledBy="Specification(s)"
                          onChange={(selected) => {
                            handleSelectChange(
                              selected.map((val) => val.value),
                              'specificationGradGroup',
                            );
                          }}
                          valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Specification(s)')}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <label htmlFor={`tech${idx}`} className="chklabel">
                    <span className="f-16 font-medium">{tech.name}</span>
                  </label>
                )}
              </div>
            </div>
          ))}

          <div className="form-group">
            <div className="m-control-outer user-right-popup d-flex align-items-center">
              <div className="common-checkbox size-sm">
                <input id="sample" type="checkbox" checked={checkIsChecked([], 'sample')} onChange={() => handleSelect('sample')} />
                <label htmlFor="sample" className="chklabel" />
              </div>
              <div className="multiselect-box po-select p-relative flex-fill ml-10">
                <div className="custom-react-select">
                  <MultiSelect
                    name="group"
                    options={mainState.sampleOptions}
                    className="product-custom-multiselect common-new-multiselect w-100"
                    value={multiselectValues('sampleOptions', 'sampleType')}
                    labelledBy="Sample(s)"
                    onChange={(selected) => {
                      handleSelectChange(
                        selected.map((val) => val._id),
                        'sampleType',
                      );
                    }}
                    valueRenderer={(selected, _options) => customValueRenderer(selected, _options, 'Sample(s)')}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <span>
              <label className="asterisk-req f-16 font-medium">
                <span>*</span> {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.TECHNICAL_PACKAGE_DOCUMENT')}
              </label>{' '}
              <div className="d-flex align-items-center">
                <p className="custom-radio mb-0 mr-3">
                  <input
                    type="radio"
                    id={`${index}detailed_yes`}
                    checked={getValue('isTechPackCombined')}
                    onChange={() => {
                      handleSelectChange(true, 'isTechPackCombined');
                    }}
                  />
                  <label className="m-0" htmlFor={`${index}detailed_yes`}>
                    {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.YES')}
                  </label>
                </p>
                <p className="custom-radio mb-0 mr-3">
                  <input
                    type="radio"
                    id={`${index}detailed_no`}
                    checked={!getValue('isTechPackCombined')}
                    onChange={() => {
                      handleSelectChange(false, 'isTechPackCombined');
                    }}
                  />
                  <label className="m-0" htmlFor={`${index}detailed_no`}>
                    {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.NO')}
                  </label>
                </p>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const submitEmail = (handleSelectChange, getValue, mainState, t) => {
  const { userList, toErr, bccErr, ccErr } = mainState;
  return (
    <Row>
      <Col md={4}>
        <FormGroup>
          <div className="input-group form-floating-label fixed-label ">
            <MentionsInput
              className="form-control"
              singleLine
              value={getValue('to') || ''}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleSelectChange(newPlainTextValue, 'to');
              }}
              style={defaultStyle}
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.ADD_USE_INFO')}
              a11ySuggestionsListLabel="Suggested mentions"
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
            </MentionsInput>

            <label>{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.TO')}</label>
          </div>
          {toErr && <small className="error-message ml-1">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.PLEASE_ADD_EMAIL')}</small>}
        </FormGroup>
      </Col>

      <Col md={4}>
        <FormGroup>
          <div className="input-group form-floating-label fixed-label">
            <MentionsInput
              className="form-control"
              singleLine
              value={getValue('cc') || ''}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleSelectChange(newPlainTextValue, 'cc');
              }}
              style={defaultStyle}
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.ADD_USER_CC')}
              a11ySuggestionsListLabel="Suggested mentions"
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val?.name} ${val?.label}`}</div>} />
            </MentionsInput>
            <label>{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.CC')}</label>
          </div>
          {ccErr && (
            <small className="error-message ml-1">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.PLEASE_ADD_VALID_EMAIL')}</small>
          )}
        </FormGroup>
      </Col>

      <Col md={4}>
        <FormGroup>
          <div className="input-group form-floating-label fixed-label">
            <MentionsInput
              className="form-control"
              singleLine
              value={getValue('bcc') || ''}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleSelectChange(newPlainTextValue, 'bcc');
              }}
              style={defaultStyle}
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.BCC_USER_EMAIL')}
              a11ySuggestionsListLabel="Suggested mentions"
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
            </MentionsInput>
            <label>{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.BCC')}</label>
          </div>
          {bccErr && (
            <small className="error-message ml-1">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.PLEASE_ADD_VALID_EMAIL')}</small>
          )}
        </FormGroup>
      </Col>

      <Col md={6}>
        <FormGroup className="mb-0">
          <div className="input-group form-floating-label fixed-label">
            <input
              type="text"
              value={getValue('message')}
              name="name"
              className="form-control"
              onChange={(e) => handleSelectChange(e.target.value, 'message')}
            />
            <label> </label>
          </div>
          <div className="common-checkbox size-sm">
            <input
              name="composeEmailId"
              id="composeEmailId"
              type="checkbox"
              checked={getValue('isCommonMessage')}
              title={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.COMMENT_MESSAGE')}
              onChange={(e) => {
                handleSelectChange(e.target.checked, 'isCommonMessage');
              }}
            />

            <label htmlFor="composeEmailId" className="chklabel" style={{ position: 'absolute', top: '0' }}>
              <span className="f-16 text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.MESSAGE')}</span>
            </label>
          </div>
        </FormGroup>
      </Col>
    </Row>
  );
};

export const sampleModule = (mainState, handleSelectChange, updateGradingGroup, addNewGradingGroup, handleGradingGroupDelete, t, lengthEnabled) => {
  const { supplierOptions, factoryOptions, sampleTypeGroupOpts, submitData, index, unitOptions, colourWayOpt, lengthOpt, gradingGroups, otherSamplesList } = mainState;

  const field = submitData[index]?.sampleRequest.gradingGroupData;
  const field1 = submitData[index]?.sampleRequest;
  const sampleErr = submitData[index]?.sampleErr;

  const selectedGroupValue = sampleTypeGroupOpts?.find((g) => g._id === field1?.sampleTypeGroupId) ||
    (field1?.typeOfSampleType === 'other' ? sampleTypeGroupOpts?.find((g) => g._id === 'other') : null);

  const sampleTypeOptionsForRow = (() => {
    if (!selectedGroupValue) return [];
    if (selectedGroupValue._id === 'other') {
      return (otherSamplesList || []).map((otherSample) => ({
        label: otherSample.name,
        value: otherSample._id,
        typeOfSampleType: 'other',
      }));
    }
    return (selectedGroupValue.sampleTypeAutomation || []).map((automation) => ({
      label: automation.sampleType?.name,
      value: automation.sampleType?._id,
      typeOfSampleType: 'main',
    }));
  })();
  return (
    <div className="p-16">
      <Row>
        <Col lg="4">
          <div className="common-react-select">
            <p className="field-name text-bold">
              {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SAMPLE_TYPE_GROUP')}
              <span className="asterisk">*</span>
            </p>
            <Select
              isClearable={false}
              options={sampleTypeGroupOpts || []}
              getOptionLabel={(o) => o?.sampleGroupName || o?.name}
              getOptionValue={(o) => o._id}
              value={selectedGroupValue || null}
              onChange={(val) => handleSelectChange(val, 'sampleTypeGroupId', true)}
              className="common-select"
              classNamePrefix="common-select"
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SAMPLE_TYPE_GROUP')}
              maxMenuHeight={174}
            />
          </div>
        </Col>

        <Col lg="4">
          <div className="common-react-select">
            <p className="field-name text-bold">
              {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SAMPLE_TYPE')}
              <span className="asterisk">*</span>
            </p>
            <Select
              isClearable={false}
              options={sampleTypeOptionsForRow}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              value={sampleTypeOptionsForRow.find((fie) => fie?.value === field1?.sampleType) || null}
              onChange={(val) => handleSelectChange(val, 'sampleType', true)}
              className="common-select"
              classNamePrefix="common-select"
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SAMPLE_TYPE')}
              maxMenuHeight={174}
              isDisabled={
                !selectedGroupValue ||
                (selectedGroupValue?._id !== 'other' &&
                  (selectedGroupValue?.sampleTypeAutomation?.[0]?.configuration?.length > 0))
              }
            />
            {sampleErr?.sampleType && (
              <small className="error-message">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SAMPLE_TYPE_REQUIRED')}</small>
            )}
          </div>
        </Col>


        <Col lg="4">
          <div className="common-react-select">
            <p className="field-name text-bold">
              {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SUPPLIER')}
              <span className="asterisk">*</span>
            </p>
            <Select
              isClearable={false}
              options={supplierOptions}
              getOptionLabel={({ label }) => label}
              getOptionValue={({ value }) => value}
              value={supplierOptions?.find((fie) => fie?._id === field1?.supplier)}
              onChange={(val) => handleSelectChange(val, 'supplier', true)}
              className="common-select"
              classNamePrefix="common-select"
              placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SUPPLIER')}
              isDisabled={field1?.parentId != null}
            />
            {sampleErr?.supplier && (
              <small className="error-message">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SUPPLIER_REQUIRED')}</small>
            )}
          </div>
        </Col>

        <Col lg="4">
          <div className="common-input-control">
            <p className="field-name text-bold">
              {t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.DUE_DATE')}
            </p>
            <div className="date">
              <div className="input-button-container">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name="dueDate"
                  popperPlace="bottom-end"
                  placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.DUE_DATE_PLACEHOLDER')}
                  valueProp={field1?.dueDate}
                  popperProps={{ strategy: 'fixed' }}
                  onChange={(date) => {
                    if (date !== 'Invalid date') {
                      handleSelectChange(date, 'dueDate', true);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Col>

        <Col lg="4">
          <FormGroup>
            <div className="common-react-select">
              <p className="field-name text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_FACTORY')}</p>
              <Select
                options={factoryOptions}
                className="common-select"
                classNamePrefix="common-select"
                getOptionLabel={({ factoryName }) => factoryName}
                getOptionValue={({ factoryId }) => factoryId}
                value={factoryOptions?.find((fie) => fie?._id === field1?.factory) || null}
                onChange={(val) => handleSelectChange(val, 'factory', true)}
                placeholder={
                  t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT') +
                  t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_FACTORY')
                }
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg="4">
          <div className="common-react-select">
            <p className="field-name text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.COLOURWAY')}</p>
            <MultiSelect
              name="colourways"
              options={colourWayOpt}
              className="product-custom-multiselect common-new-multiselect w-100"
              value={(field1?.colourwayGroup || [])?.map((id) => colourWayOpt?.find((c) => c?.value === id))?.filter(Boolean)}
              labelledBy={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_COLORWAY')}
              onChange={(selected) => {
                const ids = Array.isArray(selected) ? selected.map((v) => v?.value) : [];
                handleSelectChange(ids, 'colourwayGroup', true);
              }}
            />
          </div>
        </Col>

        <Col lg="12">
          <div className="mt-2">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="f-16 text-bold mb-0">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_COLORWAY_SIZE')}</p>
              <CustomTooltip tooltipText={t('COMMON_LABEL.ADD')}>
                <button type="button" aria-label={t('COMMON_LABEL.ADD')} onClick={() => addNewGradingGroup()} className="btn btn-outline sm">
                  <span className="icon-Add-bold" />
                </button>
              </CustomTooltip>
            </div>
            <div className="border common-border p-16 pb-1">
              {field?.map((item, index1) => (
                <Row className="mb-16" key={item?.id || index1}>
                  <Col lg="3" className="mb-2">                    
                      <div className="common-react-select mb-0 flex-fill">
                        <p className="field-name text-bold">{t('SAMPLES.COLOURWAY.GRADING_GROUP')}</p>
                        <Select
                          isClearable={false}
                          options={gradingGroups || []}
                          maxMenuHeight={132}
                          menuPosition="fixed"
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                          getOptionLabel={({ label }) => label}
                          getOptionValue={({ value }) => value}
                          value={item?.gradingGroup || null}
                          onChange={(val) => updateGradingGroup(index1, 'gradingGroup', val)}
                          className="common-select"
                          classNamePrefix="common-select"
                          placeholder={t('SAMPLES.COLOURWAY.SELECT_GRADING_GROUP')}
                        />
                      </div>
                  </Col>

                  <Col lg="2">
                    <div className="common-react-select option-placement-top mb-0">
                      <p className="field-name text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SIZE')}</p>
                      <MultiSelect
                        options={item?.sizeRanges || []}
                        value={item?.size || []}
                        onChange={(val) => updateGradingGroup(index1, 'size', val)}
                        labelledBy={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.SELECT_SIZE')}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        hasSelectAll                        
                      />
                    </div>
                  </Col>

                  {lengthEnabled && (
                    <Col>
                      <div className="common-react-select mb-0">
                        <p className="field-name text-bold">{getLengthLabel(t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.LENGTH'))}</p>
                        <Select
                          isClearable={false}
                          options={lengthOpt}
                          maxMenuHeight={132}
                          menuPosition="fixed"
                          menuPlacement="top"
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                          getOptionLabel={({ label }) => label}
                          getOptionValue={({ value }) => value}
                          value={item?.len || null}
                          onChange={(val) => updateGradingGroup(index1, 'len', val)}
                          className="common-select"
                          classNamePrefix="common-select"
                          placeholder={getLengthLabel(t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.LENGTH'))}
                        />
                      </div>
                    </Col>
                  )}

                  <Col>
                    <div className="common-input-control mb-0">
                      <p className="field-name text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.QUANTITY')}</p>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => updateGradingGroup(index1, 'quantity', e.target.value)}
                        value={item?.quantity || ''}
                      />
                    </div>
                  </Col>

                  <Col lg="3">
                    <div className="d-flex align-items-end">
                      <div className="common-react-select flex-fill mb-0">
                        <p className="field-name text-bold">{t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.UOM')}</p>
                        <Select
                          isClearable={false}
                          options={unitOptions}
                          maxMenuHeight={132}
                          menuPosition="fixed"
                          menuPlacement="top"
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                          getOptionLabel={({ label }) => label}
                          getOptionValue={({ value }) => value}
                          value={item?.uom || null}
                          onChange={(val) => updateGradingGroup(index1, 'uom', val)}
                          className="common-select"
                          classNamePrefix="common-select"
                          placeholder={t('DEVLOPMENT_ORDERS.PRODUCT_INFO.SUBMIT_POP_UP.COMMON_SUBMIT_MODULE.UOM')}
                        />
                      </div>
                      <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
                          <button
                            type="button"
                            aria-label={t('COMMON_LABEL.DELETE')}
                            onClick={() => handleGradingGroupDelete(index1)}
                            className="btn btn-outline sm ml-16"
                            disabled={field.length <= 1}
                          >
                            <span className="icon-Delete-bold" />
                          </button>
                        </CustomTooltip>
                      </div>
                  </Col>                  
                </Row>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
